import { connect } from 'react-redux'
import TabNav from './tab-nav'
import { getCurrentCounter } from '../../../../stores/current-invitations/current-invitations.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => {
  const canManageAFs =
    me &&
    me.account &&
    me.account.policy &&
    me.account.policy.can_manage_assessment_files
  const canSeeTrainingFiles =
    me &&
    me.account &&
    me.account.policy &&
    me.account.policy.can_see_training_materials
  return {
    currentCounter: getCurrentCounter(state),
    canManageAFs,
    canSeeTrainingFiles
  }
}

export default withMe(
  connect(
    mapStateToProps,
    null
  )(TabNav)
)
